<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <login-card header-color="green">
        <h4 slot="title" class="title">{{ title }} - Log&nbsp;in</h4>
        <span slot="buttons">{{ this.loadingMsg }}</span>
        <md-field
          class="md-form-group"
          :class="getUsernameErrorClass"
          slot="inputs"
        >
          <md-icon>email</md-icon>
          <label>E-mailadres</label>
          <md-input
            v-model="email"
            type="email"
            v-on:keyup.enter="login()"
          ></md-input>
        </md-field>
        <md-field
          class="md-form-group"
          :class="getPasswordErrorClass"
          slot="inputs"
        >
          <md-icon>lock_outline</md-icon>
          <label>Wachtwoord</label>
          <md-input
            v-model="password"
            type="password"
            v-on:keyup.enter="login()"
          ></md-input>
        </md-field>
        <md-button
          slot="footer"
          class="md-button md-success md-lg"
          v-on:click="login()"
          :disabled="requesting"
        >
          Inloggen
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
export default {
  components: {
    LoginCard
  },
  data() {
    return {
      email: null,
      password: null,
      loginErrors: {},
      requesting: false,
      loggedIn: false,
      loadingMsg: "",
      title: process.env.VUE_APP_TITLE
    };
  },
  methods: {
    login() {
      this.loginErrors = {};
      this.requesting = true;
      this.loadingMsg = "Bezig met inloggen...";
      this.$http
        .post(
          this.$apiBaseUrl + "login",
          { username: this.email, password: this.password },
          { emulateJSON: true }
        )
        .then(
          response => {
            let timestamp = Math.floor(Date.now() / 1000);

            localStorage.setItem(
              "expires_on",
              timestamp + response.data.expires_in
            );
            localStorage.setItem("access_token", response.data.access_token);
            localStorage.setItem("refresh_token", response.data.refresh_token);

            this.loadingMsg = "Gebruikers gegevens laden...";
            this.$http.get(this.$apiBaseUrl + "user").then(
              response => {
                localStorage.setItem("user_id", response.data.id);
                localStorage.setItem("user_firstName", response.data.firstName);
                localStorage.setItem("user_lastName", response.data.lastName);
                localStorage.setItem(
                  "user_lastNamePrefix",
                  response.data.lastNamePrefix == null
                    ? ""
                    : response.data.lastNamePrefix
                );
                localStorage.setItem("user_email", response.data.email);

                this.loadingMsg = "Gebruikers rechten laden...";
                this.$http.get(this.$apiBaseUrl + "user/roles").then(
                  response => {
                    localStorage.setItem("user_roles", response.data.roles);
                    localStorage.setItem(
                      "user_scopes",
                      this.parseJwt(localStorage.getItem("access_token")).scopes
                    );

                    this.notifyVue(
                      "Succesvol ingelogd",
                      "add_alert",
                      "success",
                      5000
                    );
                    this.$router.push("/dashboard");
                  },
                  response => {
                    this.requesting = false;
                    this.loadingMsg = "";

                    this.notifyVue(
                      "Problemen met het ophalen van de gebruikersrollen.",
                      "add_alert",
                      "danger",
                      0
                    );
                  }
                );
              },
              response => {
                this.requesting = false;
                this.loadingMsg = "";

                this.notifyVue(
                  "Problemen met het ophalen van de gebruikersgegevens.",
                  "add_alert",
                  "danger",
                  0
                );
              }
            );
          },
          response => {
            this.requesting = false;
            this.loadingMsg = "";

            this.loginErrors = response.data.errors;
            this.notifyVue(this.getErrorMessage, "add_alert", "danger", 0);
          }
        );
    },
    parseJwt(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  computed: {
    getErrorMessage: function() {
      let msg =
        "Het volgende problemen is geconstateerd tijdens het inloggen: ";

      for (let i in this.loginErrors) {
        if (i === "password" && this.loginErrors[i] === "missing") {
          msg += "Wachtwoord ontbreekt";
        } else if (i === "username" && this.loginErrors[i] === "missing") {
          msg += "E-mailadres ontbreekt";
        } else if (i === "credentials" && this.loginErrors[i] === "incorrect") {
          msg += "Ongeldig e-mailadres en/of wachtwoord";
        } else {
          msg += "Onbekende fout!";
        }
      }

      return msg;
    },
    getUsernameErrorClass: function() {
      return this.loginErrors.username !== undefined ||
        this.loginErrors.credentials !== undefined
        ? "md-error"
        : "";
    },
    getPasswordErrorClass: function() {
      return this.loginErrors.password !== undefined ||
        this.loginErrors.credentials !== undefined
        ? "md-error"
        : "";
    }
  }
};
</script>

<style></style>
